// extracted by mini-css-extract-plugin
export default {"summaryNumber":"kY2O8Tngci0zmDbv0KDL"};